<template>
  <div  v-if="fetchData" class="content block__width-995 fullpage-container">
      <full-page :options="options" @after-load="afterLoad">
        <div class="section" data-menuanchor="page1" id="section1">
            <div class="chart">
              <div class="chart__title">{{chartTitle}}</div>
              <div class="chart-block">
                <div class="chart__address">
                  {{chartAddress}}
                </div>
                <div class="chart__value">
                  {{chartValue}}
                  <span>
                    мгм/м3
                  </span>
                </div>
              </div>

            </div>
            <div class="chart__interactive">
              <div class="chart__info">
                <div class="chart__info-top" v-bind:style="infoStyle">
                  <div class="chart__info-top-title">
                    {{infoTitle}}
                  </div>
                  <div class="chart__info-top-desc">
                    {{infoDesc}}
                  </div>
                </div>
                <div class="chart__info-bottom">
                  <div class="chart__info-bottom-item chart__info-bottom-item1">
                    <div class="chart__info-bottom-label">Температура<br>C</div>
                    <div class="chart__info-bottom-value">{{infoHumidity}}</div>
                  </div>
                  <div class="chart__info-bottom-item chart__info-bottom-item2">
                    <div class="chart__info-bottom-label">Влажность<br>%</div>
                    <div class="chart__info-bottom-value">{{infoTemp}}</div>
                  </div>
                </div>

              </div>
              <div class="chart__diagram">
                <div class="custom-select">

                  <!--<select class="chart__select" v-model="chartPeriod">-->
                    <div class="custom-select__item custom-select__item1" v-bind:class="{customSelecActive: activeLink === 1}" @click="changePeriod('day', 1)">за сутки</div>
                    <div class="custom-select__item" v-bind:class="{customSelecActive: activeLink === 2}" @click="changePeriod('week', 2)">за неделю</div>
                  <!--</select>-->
                </div>
                  <line-chart :fetchData="fetchData" :chartPeriod="chartPeriod" class="line-chart"></line-chart>
              </div>
            </div>
            <div @click="this.moveSectionDown" class="scroll-button"></div>
        </div>
        <div class="section" id="section2" data-menuanchor="page2">
          <div class="map-desc">
            Нажмите на маркер, чтобы посмотреть данные этого датчика
          </div>
          <GmapMap
            :center="{lat:42.874602, lng:74.609141}"
            :zoom="13"
            style="width: 100%; height: 450px"
          >
            <GmapMarker
              :key="index"
              v-for="(m, index) in markers"
              :icon="m.icon"
              :position="m.position"
              :clickable="true"
              :draggable="false"
              @click="buildMap(m.position)"
            />
          </GmapMap>
          <div @click="this.moveSectionDown" class="scroll-button"></div>
        </div>
        <div class="section" id="section3" data-menuanchor="page3">
          <info :fetchData = "fetchData"></info>
        </div>
      </full-page>

  </div>
</template>

<script>
  import LineChart from '@/components/LineChart'
  import Info from '@/components/Info'
  import FullPage from 'vue-fullpage.js/src/fullPage.vue'
  import fullPageMixin from 'vue-fullpage.js/src/fullPageMixin'
  import $ from 'jquery'
  export default {
    name: 'VueChartJS',
    mixins: [fullPageMixin],
    components: {
      LineChart, Info, FullPage
    },
    data () {
      return {
        fetchData: false,
        chartPeriod: 'day',
        chartTitle: 'Твердые частицы',
        chartAddress: '',
        chartValue: '',
        infoTitle: '',
        infoDesc: '',
        infoHumidity: '',
        infoTemp: '',
        markers: [],
        activeLink: 1,
        infoStyle: {
          backgroundColor: ''
        },
        options: {
          afterLoad: this.afterLoad,
          scrollBar: false,
          navigation: false,
          css3: true,
          anchors: ['diagram', 'map', 'info']
        }
      }
    },
    created () {
      this.getData(42.874602, 74.609141)
    },
    methods: {
      afterLoad () {
      },
      changePeriod: function (val, active) {
        $('.custom-select__item').removeClass('customSelecActive')
        this.chartPeriod = val

        this.activeLink = active
      },
      buildMap: function (pos) {
        this.chartPeriod = 'day'
        this.activeLink = 1
        this.getData(pos.lat, pos.lng)
        if (($(window).width() > 995) && ($(window).height() > 850)) {
          this.moveSectionUp(1)
        } else {
          $('html,body').animate({
            scrollTop: $('.chart').offset().top
          })
        }
      },
      createMarker: function (color, value) {
        let template = [
          '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 104 145.29"><defs><style>.cls-1{fill:{{ color }};}.cls-2{opacity:0.15;}.cls-2,.cls-3{font-size:30.95px;font-family:SegoeUI-Semilight, Segoe UI;text-align:center;margin-left:10px;}.cls-3{fill:#fff;}</style><linearGradient id="Безымянный_градиент_8" x1="52" y1="145.29" x2="52" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#f15a24"/><stop offset="1" stop-color="#f18a24"/></linearGradient></defs><title>ic_map.marker</title><g id="Слой_2" data-name="Слой 2"><g id="Слой_1-2" data-name="Слой 1"><path class="cls-1" d="M104,52c0,28.72-52,93.29-52,93.29S0,80.72,0,52a52,52,0,0,1,104,0Z"/><text xmlns="http://www.w3.org/2000/svg" y="58">\n' +
          '    <tspan x="49%" class="cls-3" text-anchor="middle">{{ value }}</tspan>\n' +
          '    \n' +
          '  </text></g></g></svg>'
        ].join('\n')
        return template
          .replace('{{ color }}', color)
          .replace('{{ value }}', value)
      },
      getData: function (latitude, longitude) {
        let self = this
        let url = 'http://movegreen.kg/api/json.php?latitude=' + latitude + '&longitude=' + longitude
        this.$http.get(url, {
          method: 'GET'
        })
          .then(response => {
            self.fetchData = response.data.data
            if (self.fetchData) {
              this.$emit('pageStatus', true)
            }
            self.chartAddress = response.data.data.address
            self.chartValue = response.data.data.current.particulate_matter
            self.infoTitle = response.data.data.status_title
            self.infoDesc = response.data.data.status_text
            self.infoStyle.backgroundColor = response.data.data.status_color
            self.infoTemp = response.data.data.current.temperature
            self.infoHumidity = response.data.data.current.humidity
            response.data.data.points.forEach(function (element) {
              self.markers.push({
                position: {lat: parseFloat(element.latitude), lng: parseFloat(element.longitude)},
                icon: {
                  url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(unescape(encodeURIComponent(self.createMarker(element.color, element.particulate_matter)))),
                  scaledSize: {width: 50, height: 70, f: 'px', b: 'px'}
                }
              })
            })
          })
          .catch(error => {
            console.log(error)
          })
      }
    }
  }
</script>
<style scoped>
  .fullpage-container{
    height:100%;
    position:relative;
  }
  .page-container {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .chart {
    max-width: 576px;
    text-align: center;
    margin:0 auto
  }
  .chart-block{
    margin:10px 0
    /*margin:25px 0*/
  }
  .chart__select{
    font-size: 12px;
    text-transform: uppercase;
    background: 0;
    border: 0;
    color: #fff;

  }
  .custom-select{
    position: absolute;
    top: 12px;
    width: 100%;
    text-align: center;
  }
  .custom-select option {
    background: #fff;
    color: #000;
    padding:10px 0
  }
  .chart__title{
    font-size: 36px;
    font-weight: 300;
    line-height: 1.2;
    text-shadow: 0px 2px 0 rgba(0, 0, 0, 0.15);
  }
  .chart__address{
    font-size: 24px;
    font-weight: 600;
    text-shadow: 0px 2px 0 rgba(0, 0, 0, 0.15);
  }
  .custom-select__item{
    display: inline-block;
    text-transform: uppercase;
    display: inline-block;
    font-size: 14px;
    cursor:pointer
  }
  .customSelecActive{
    border-bottom:1px solid #65f289
  }
  .custom-select__item1{
    margin-right: 25px;
  }
  .chart__value{
    font-size: 48px;
    font-weight: 600;
    text-shadow: 0px 2px 0 rgba(0, 0, 0, 0.15);
    margin-left: auto;
  }
  .chart__value span{
    font-size: 16px;
    font-weight: 400;
    margin-left: -5px;
  }
  .chart__diagram{
    background-color: #4396e3;
    box-shadow: 0px 4px 10px 0 rgba(0, 0, 0, 0.15);
    padding: 40px 0 20px;
    position:relative;
    max-width:535px;
    height:300px;
    width: 100%;
  }
  .chart__info-top-title{
     text-align: center;
     margin:25px 0 15px;
     font-size: 16px;
     font-weight: 600;
     text-transform:uppercase

   }
  .chart__info-bottom-item1{
    padding-bottom:15px;
    border-bottom:1px solid #dedede
  }
  .chart__info-bottom-item2{
   margin-top:15px;
  }
  .chart__info-top-desc{
    text-align: center;
    margin-bottom:25px;
    font-size: 16px;

  }
  .chart__info-top{
    overflow: hidden;
    max-width:545px;
    box-shadow: 0px 4px 10px 0 rgba(0, 0, 0, 0.15);
    padding:0 15px
  }
  .chart__interactive{
    margin: 0 auto;
    max-width: 575px;
  }
  .chart__info-bottom{
    max-width: 525px;
    /*max-width: 305px;*/
    background: #fff;
    padding: 25px;
    margin: 15px 0 50px;
    color: rgba(0, 0, 0, 0.87);
  }
  .chart__info-bottom-item{
    display: flex;
    display: -ms-flex;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
  }
  .chart__info-bottom-label{
    font-size: 16px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
  }
  .chart__info-bottom-value{
    font-size: 36px;
    font-weight: 300;
    margin-left:auto
  }
  .line-chart{
    height:300px;
  }
  @media (min-width: 600px) {
    .chart-block{
      display: -webkit-flex;
      display: -ms-flex;
      display: flex;
      -webkit-align-items: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
    .chart__title {
      font-size: 40px;
    }
    .chart{
      text-align:left;
    }
    .chart__diagram{
      padding: 40px 20px 20px;

    }
  }
  @media (min-width: 995px) {
    .chart__interactive{
      display: -webkit-inline-flex;
      display: inline-flex;
      flex-direction: row-reverse;
      margin:0;
      width: 100%;
      max-width: 995px;

    }
    .chart-block{
      margin:25px 0
    }
    .chart__info-bottom{
      /*padding-bottom:0;*/
      margin-bottom:0
    }
    .chart{
      margin:0;

    }
    .chart__info{
      margin-left: 61px;
      width: 359px;
    }
  }

</style>



// WEBPACK FOOTER //
// VueChartJS.vue?5d624c54